import classNames from 'classnames';
import PropTypes from 'prop-types';

const SearchListIcon = ({ className }) => {
  const iconClassName = classNames('search-list-icon', className);

  return (
    <svg className={iconClassName} width='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 9.59992C6 7.2435 7.91025 5.33325 10.2667 5.33325C12.6231 5.33325 14.5333 7.2435 14.5333 9.59992C14.5333 10.5376 14.2309 11.4045 13.7182 12.1087L15.1381 13.5285C15.3984 13.7889 15.3984 14.211 15.1381 14.4713C14.8777 14.7317 14.4556 14.7317 14.1953 14.4713L12.7754 13.0515C12.0713 13.5641 11.2043 13.8666 10.2667 13.8666C7.91025 13.8666 6 11.9563 6 9.59992ZM10.2667 6.66659C8.64663 6.66659 7.33333 7.97988 7.33333 9.59992C7.33333 11.22 8.64663 12.5333 10.2667 12.5333C11.8867 12.5333 13.2 11.22 13.2 9.59992C13.2 7.97988 11.8867 6.66659 10.2667 6.66659Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.666652 6.66667C0.666654 6.29848 0.965133 6 1.33332 6L4.66666 6.00003C5.03485 6.00003 5.33332 6.29851 5.33332 6.6667C5.33332 7.03489 5.03484 7.33336 4.66665 7.33336L1.33331 7.33334C0.965124 7.33334 0.666649 7.03486 0.666652 6.66667Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.666656 11.3332C0.666656 10.965 0.965133 10.6665 1.33332 10.6665H4.66666C5.03485 10.6665 5.33332 10.965 5.33332 11.3332C5.33332 11.7014 5.03485 11.9998 4.66666 11.9998H1.33332C0.965133 11.9998 0.666656 11.7014 0.666656 11.3332Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.666656 1.99992C0.666656 1.63173 0.965133 1.33325 1.33332 1.33325H12.6667C13.0348 1.33325 13.3333 1.63173 13.3333 1.99992C13.3333 2.36811 13.0348 2.66659 12.6667 2.66659H1.33332C0.965133 2.66659 0.666656 2.36811 0.666656 1.99992Z'
        fill='currentColor'
      />
    </svg>
  );
};

SearchListIcon.propTypes = {
  className: PropTypes.string,
};

export default SearchListIcon;
